export const communicationStatus = {
  IDLE: 'idle',
  FETCHING: 'fetching',
  ERROR: 'error',
  CLIENT_ERROR: 'clientError',
  TIMEOUT: 'timeout',
};

export const contactMethods = {
  default: {
    emails: ['team-supply@student.com'],
    phones: ['44 (0) 203 817 0050'],
  },
  au: {
    emails: ['team-supply@student.com'],
    phones: ['864009200606'],
  },
  us: {
    emails: ['usa@student.com'],
    phones: ['1 718 709 9007'],
  },
  hk: {
    emails: ['team-supply@student.com'],
    phones: null,
  },
};

export const longtailStatusTabs = {
  all: 'all',
  applicationProcessing: 'application_processing',
  completed: 'completed',
};

export const pbsaStatusTabs = {
  all: 'all',
  readyForApproval: 'ready_for_approval',
  pendingApproval: 'pending_approval',
  approved: 'approved',
  readyToInvoice: 'ready_to_invoice',
  invoiced: 'invoiced',
  paid: 'paid',
};

export const longtailStatusArr = ['APPLICATION_PROCESSING', 'COMPLETED'];

export const pbsaLandlordBookingStatusArr = [
  'READY_FOR_APPROVAL',
  'PENDING_APPROVAL',
  'APPROVED',
  'READY_TO_INVOICE',
  'INVOICED',
  'PAID',
];

export const defaultFilterValues = {
  propertyId: 'all_properties',
  status: 'all',
  page: 1,
  fromDate: 'completed_any_any',
};

export const storage = {
  keys: {
    filters: 'LANDLORD_LAST_FILTERS',
  },
  version: 'v1',
};

export const commissionType = {
  FLAT_FEE: 'FLAT_FEE',
};

export const roomTypes = ['PRIVATE_ROOM', 'SHARED_ROOM', 'ENTIRE_PLACE'];

export const landlordListLabel = ['name', 'landlord_app_id', 'booking_id', 'booking_value'];

export const hostNames = {
  'ENVIRONMENT:PROD': '//student.com',
  'ENVIRONMENT:STAGE': '//hurricane-www.dandythrust.com',
  'ENVIRONMENT:UAT': '',
  'ENVIRONMENT:DEV': '//127.0.0.1:8201',
};

export const setupStatus = [
  'initial-setup',
  'receiving-payments',
  'deposit',
  'first-instalment',
  'terms-and-conditions',
  'enable-payments',
];

export const longtailSetupStatus = ['initial-setup', 'deposit', 'rent-payment', 'enable-payments'];

export const paymentProcessStatus = {
  online: 'ONLINE',
  offline: 'OFFLINE',
};

export const paymentCategoryTypes = {
  studentDeposit: 'Student deposit',
  transactionFee: 'Transaction fee',
};

export const paymentTermsAndConditionsTableTitleList = {
  title: 'Terms & Conditions name',
  url: 'URL',
  validFrom: 'Valid from',
  validTill: 'Valid to',
};

export const longtailSummaryItems = [
  {
    t: 'pending',
    className: 'pending',
    value: 'applicationProcessingCount',
  },
  {
    t: 'confirmed',
    className: 'confirmed',
    value: 'completedCount',
  },
];

export const pbsaSummaryItems = [
  {
    t: 'ready_for_approval',
    className: 'ready-for-approval',
    value: 'readyForApproval',
  },
  {
    t: 'pending_approval',
    className: 'pending-approval',
    value: 'pendingApproval',
  },
  {
    t: 'approved',
    className: 'approved',
    value: 'approved',
  },
  {
    t: 'ready_to_invoice',
    className: 'ready-to-invoice',
    value: 'readyToInvoice',
  },
  {
    t: 'invoiced',
    className: 'invoiced',
    value: 'invoiced',
  },
  {
    t: 'paid',
    className: 'paid',
    value: 'paid',
  },
];

export const bookingSortBy = {
  moveInDate: 'MOVE_IN_DATE',
  moveOutDate: 'MOVE_OUT_DATE',
  completedAt: 'COMPLETED_AT',
  updatedAt: 'UPDATED_AT',
};

export const bookingSortDirection = {
  ascending: 'ASCENDING',
  descending: 'DESCENDING',
};

export const cookieNames = {
  token: 'LANDLORDACCESSSESSION',
  landlordToken: 'LANDLORDACCESSSESSION',
};

export const addStatus = {
  content: 0,
  map: 1,
  admin: 2,
};

export const locales = [
  'EN_US',
  'ZH_CN',
  'DE_DE',
  'EL_GR',
  'ES_ES',
  'FR_FR',
  'IT_IT',
  'JA_JP',
  'KO_KR',
  'TH_TH',
  'ZH_HK',
  'VI_VN',
];

export const offerTypes = ['VOUCHER', 'DISCOUNT', 'CASHBACK', 'GROUP_OFFER', 'PROMOTION'];

export const offerType = {
  VOUCHER: 'VOUCHER',
  DISCOUNT: 'DISCOUNT',
  CASHBACK: 'CASHBACK',
  GROUP_OFFER: 'GROUP_OFFER',
  PROMOTION: 'PROMOTION',
};

export const tenancyUnitTypes = ['MONTH', 'WEEK', 'DAY'];

export const mapType = {
  property: 'property',
  city: 'city',
};

export const endDate = {
  yes: 'haveEndDate',
  no: 'notHaveEndDate',
};

export const offerCategory = {
  exclusive: true,
  nonExclusize: false,
};

export const operateType = {
  edit: 'edit',
  add: 'add',
};

export const displayForm = {
  page: 'page',
  modal: 'modal',
};

export const offerOwnerType = {
  student: 'INTERNAL',
  landlord: 'LANDLORD',
};

export const displayType = ['CN', 'GB', 'US', 'AU', 'IN', 'JP', 'KR'];

export const displaySetting = {
  default: 'default',
  accordingIPAddress: 'according_ip_address',
};

export const userRole = 'content_manager';

export const landlordRole = 'landlord';

export const sortDirectionMapping = {
  ascend: 'ASCENDING',
  descend: 'DESCENDING',
  ASCENDING: 'ascend',
  DESCENDING: 'descend',
};

export const sortByMapping = {
  updatedAt: 'UPDATED_AT',
  unitType: 'UNIT_TYPE_ID',
  unitTypeName: 'UNIT_TYPE_NAME',
  distinctionTypeName: 'DISTINCTION_TYPE_NAME',
  distinctionName: 'DISTINCTION_NAME',
  price: 'PRICE_MIN',
  startDate: 'START_DATE',
  endDate: 'END_DATE',
  maxBookings: 'MAX_BOOKINGS',
  createdAt: 'CREATED_AT',
  amount: 'AMOUNT',
  UPDATED_AT: 'updatedAt',
  UNIT_TYPE_ID: 'unitType',
  UNIT_TYPE_NAME: 'unitTypeName',
  DISTINCTION_NAME: 'distinctionName',
  DISTINCTION_TYPE_NAME: 'distinctionTypeName',
  PRICE_MIN: 'price',
};

export const countrySortByMapping = {
  countrySlug: 'SLUG',
  countryCode: 'COUNTRY_CODE',
  currencyCode: 'CURRENCY_CODE',
  numOfProperties: 'PUBLISHED_PROPERTIES',
  updatedAt: 'UPDATED_AT',
};

export const citySortByMapping = {
  updatedAt: 'UPDATED_AT',
  name: 'NAME',
  numOfProperties: 'PROPERTIES',
  rank: 'RANK',
};

export const areaSortByMapping = {
  name: 'NAME',
  updatedAt: 'UPDATED_AT',
  numOfProperties: 'PUBLISHED_PROPERTIES',
};

export const universitySortByMapping = {
  commonNamesCount: 'NAME',
  updatedAt: 'UPDATED_AT',
};

export const accountSortByMapping = {
  updatedAt: 'UPDATED_AT',
};

export const propertyListingForm = {
  statuses: {
    new: 'NEW',
    drafts: 'DRAFTS',
    published: 'PUBLISHED',
    unpublished: 'UNPUBLISHED',
    editing: 'EDITING',
  },
  listingType: {
    fixed: 'FIXED',
    fixedOpenEnd: 'FIXED_OPEN_END',
    flexible: 'FLEXIBLE',
    flexibleOpenEnd: 'FLEXIBLE_OPEN_END',
    placeholder: 'PLACEHOLDER',
  },
  availability: {
    good: 'GOOD',
    limited: 'LIMITED',
    soldOut: 'SOLD_OUT',
  },
  discountType: {
    no: 'NO',
    absolute: 'ABSOLUTE',
    percentage: 'PERCENTAGE',
  },
  priceType: {
    exact: 'EXACT',
    range: 'RANGE',
  },
};

export const unitTypesForm = {
  category: {
    ensuiteRoom: 'ENSUITE_ROOM',
    entirePlace: 'ENTIRE_PLACE',
    privateRoom: 'PRIVATE_ROOM',
    sharedRoom: 'SHARED_ROOM',
    studio: 'STUDIO',
  },
  floorplanAreaDisplayUnit: {
    sqft: 'SQFT',
    m2: 'M2',
  },
  genderMix: {
    maleOnly: 'MALE_ONLY',
    femaleOnly: 'FEMALE_ONLY',
    mixed: 'MIXED',
  },
  dietaryPreference: {
    vegetarian: 'VEGETARIAN',
  },
  smokingPreference: {
    nonSmoking: 'NON_SMOKING',
    smoking: 'SMOKING',
  },
  bathroomTypes: {
    privateEnsuite: 'PRIVATE_ENSUITE',
    privateNonEnsuite: 'PRIVATE_NON_ENSUITE',
    sharedEnsuite: 'SHARED_ENSUITE',
    sharedNonEnsuite: 'SHARED_NON_ENSUITE',
    mixed: 'MIXED',
  },
};

export const googleMapKey = 'AIzaSyAo3z-iOKf-Mto5TsHcsjXylWdxCt7zZDk';

export const updateMutation = {
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  INSERT: 'INSERT',
  NEW: 'NEW',
};

export const propertyState = {
  AVAILABLE_WITH_PRICE: 'AVAILABLE_WITH_PRICE',
  AVAILABLE: 'AVAILABLE',
  COMING_SOON: 'COMING_SOON',
  SOLD_OUT: 'SOLD_OUT',
  INACTIVE: 'INACTIVE',
};

export const locationType = {
  COUNTRY_TYPE: 'Country',
  CITY_TYPE: 'City',
  AREA_TYPE: 'Area',
  UNIVERSITY_TYPE: 'University',
};

export const locationTabType = {
  DETAILS: 'details',
  CONTENT: 'content',
  SEO: 'seo',
};

export const depositType = {
  FIXED_AMOUNT: 'FIXED_AMOUNT',
  PER_BILLING_CYCLE: 'PER_BILLING_CYCLE',
  DEPOSIT_PERCENTAGE: 'DEPOSIT_PERCENTAGE',
};

export const draftType = {
  EDITING: 'EDITING',
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED',
};

export const platformEntity = {
  PROPERTIES_PROPERTIES: 'properties.properties',
  PROPERTIES_UNIT_TYPES: 'properties.unit_types',
  LISTINGS_LISTINGS: 'listings.listings',
  COMMISSION_COMISSION_TIERS: 'commission.commission_tiers',
  PROPERTIES_TERMS: 'payments.terms_and_conditions',
  PROPERTIES_PROPERTIES_CONTRACTS: 'properties.property_contracts',
  PAYMENTS_LINE_ITEM_RULES: 'payments.line_item_rules',
  LOCATIONS_COUNTRIES: 'locations.countries',
  LOCATIONS_CITIES: 'locations.cities',
  LOCATIONS_AREAS: 'locations.areas',
  UNIVERSITIES_UNIVERSITIES: 'universities.universities',
  PROPERTIES_CONTRACTS: 'properties.contracts',
  SPECIAL_OFFERS_SPECIAL_OFFERS: 'special_offers.special_offers',
  IDENTITY_CMS_USERS: 'identity.cms_users',
};
export const entityAction = {
  CREATE: 'C',
  READ: 'R',
  UPDATE: 'U',
  DELETE: 'D',
};

export const pmsAllowRoles = ['landlord'];

export const createCmsUserType = {
  EMAIL: 'EMAIL',
};

export const apCategory = {
  STANDARD: 'STANDARD',
  KEY: 'KEY',
};

export const paymentPlanCategoryType = {
  DEPOSIT_IS_REQUIRED: 'DEPOSIT_IS_REQUIRED',
  RENT_IS_REQUIRED: 'RENT_IS_REQUIRED',
};
